const ls = require("lightstreamer-client-web");
import { getCurrentUser } from "utils/user";

const lsStatus = {
  CONNECTING: "CONNECTING",
  CONNECTED_STREAM_SENSING: "CONNECTED:STREAM-SENSING",
  DISCONNECTED: "DISCONNECTED",
  DISCONNECTED_WILL_RETRY: "DISCONNECTED:WILL-RETRY",
  CONNECTED_WS_STREAMING: "CONNECTED:WS-STREAMING",
};

let instance;
let count = 0;

function createInstance() {
  const user = getCurrentUser();

  const LSUrl = String(process.env.REACT_APP_LS_URL);
  const adapter = "PROXY_Infosel";

  const client = new ls.LightstreamerClient(LSUrl, adapter);

  if (user !== null) {
    client.connectionDetails.setUser(user.userName);
    client.connectionDetails.setPassword(user.access_token);
  }

  client.addListener({
    onStatusChange(status) {
      if (status === lsStatus.DISCONNECTED_WILL_RETRY) {
        count += 1;
        if (count > 5) {
          const server = client.connectionDetails.getServerAddress();
          // eslint-disable-next-line no-console
          console.log(`No se pudo conectar al servidor: ${server}`);
          client.connectionDetails.setServerAddress("https://streamingcloud.infosel.com");
        }
      }
      if (status === lsStatus.CONNECTED_STREAM_SENSING) {
        const server = client.connectionDetails.getServerAddress();
        // eslint-disable-next-line no-console
        console.log(`Se conecto al servidor de LS: ${server}`);
        count = 0;
      }
    },
  });
  client.connect();

  return client;
}

const lsClient = () => {
  if (!instance) {
    instance = createInstance();
  }
  return instance;
};
export default lsClient;
